import styled from 'styled-components';

export const CustomIcon = styled.img`
  ${({ width }) => (width ? `width: ${width}px;` : '')}
  ${({ height }) => (height ? `height: ${height}px;` : '')}
`;
